import isNumber from 'utilities/isNumber';

import { getAgentNpn } from './getSessionData';

const putJSON = async ({ body, url }) => {
    const agentNpn = getAgentNpn();
    const options = {
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            ...(isNumber(agentNpn) && { isPurl: true }),
            ...(agentNpn && { AgentNPN: agentNpn })
        },
        method: 'PUT'
    };

    try {
        return (await fetch(url, options)).json();
    } catch (error) {
        console.error(error);

        return {};
    }
};

export default putJSON;
